import React from "react";
import { Helmet } from "react-helmet";

const AppHelmet = () => {
  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>InboundJunction CRM</title>
      <link rel="canonical" href="http://mysite.com/example" />
    </Helmet>
  );
};

export default AppHelmet;
